<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :canEdit="canEdit"
        :disabled="disabled"
        :submitBtn="!disabled"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record.begin_time }} 至 {{ record.end_time }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'edit'"
              v-if="
                record.state === 0 || record.state === 3 || record.state === 4
              "
            >
              编辑
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-popconfirm
              title="确认提交？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="pushRow(record)"
              v-if="record.state === 0"
            >
              <a-button>提交</a-button>
            </a-popconfirm>
            <a-popconfirm
              title="确认撤销审核？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="revokeRow(record)"
              v-if="record.state === 1 || record.state === 2"
            >
              <a-button danger>撤销审核</a-button>
            </a-popconfirm>
            <a-popconfirm
              v-if="record.state !== 1 && record.state !== 2"
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    getDetail,
    pushData,
    revoke,
    approvalProcess,
  } from '@/api/car_application/car_registration'
  import action from './action'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText } from '@/utils/format'
  import approval_process from '@/components/approval_process'

  //初始化
  const pageName = '车辆备案'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '状态',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'begin_time',
      endField: 'end_time',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setCarRegistration', params)
  }

  //2、表格
  const columns = [
    {
      title: '受理单号',
      dataIndex: 'application_number',
      key: 'application_number',
      align: 'left',
    },
    {
      title: '园区类型',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
    },
    {
      title: '车牌颜色',
      dataIndex: 'license_plate_color',
      key: 'license_plate_color',
      align: 'left',
      width: 90,
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      align: 'left',
    },
    {
      title: '时间',
      key: 'time_range',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '修改时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '260px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchCarRegistration)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)
  const disabled = ref(false)
  const canEdit = ref(true)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    canEdit.value = true
    disabled.value = false
    open.value = true
  }
  const showDetailModal = async (data) => {
    loadingRecord.value = data[idField] + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      disabled.value = true
      canEdit.value = false
      open.value = true
    }
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data[idField] + 'edit'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      disabled.value = false
      canEdit.value = true
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    }
  }

  //5、提交
  async function pushRow(data) {
    const res = await pushData({ id: data[idField] })
    if (res.success) {
      message.success('提交成功！')
      fetch()
    }
  }
  //6、撤销审核
  async function revokeRow(data) {
    const res = await revoke({ id: data[idField] })
    if (res.success) {
      message.success('撤销审核成功！')
      fetch()
    } else {
      message.warn('撤销审核失败' + res.message)
    }
  }
  //7、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }
</script>
